export const LOGO_URL = "/media/logo.png";
export const HERO_VIDEO_URL = "/media/hero.mp4";
export const HERO_VIDEO_WEBM = "/media/hero.webm";

export const NAV_ITEMS = [
  { label: "Academy", href: "#academy" },
  { label: "Courses", href: "#courses" },
  { label: "Ecosystem", href: "#ecosystem" },
  { label: "Who It's For", href: "#audience" },
  { label: "About", href: "#about" },
];

export const HERO_CUES = [
  {
    at: 0.00,
    eyebrow: "01. The Empowerment Zone",
    title: "Talent Is Everywhere. Opportunity Is Not.",
    body: "SAMZ is the AI-powered ecosystem closing the gap between real talent and real opportunity. Built for the people actually doing the work.",
  },
  {
    at: 0.34,
    eyebrow: "02. Learning To Earning",
    title: "You Have The Talent. Now Get The Blueprint.",
    body: "Six courses. One certification. The SAMZONE Badge. Move from skill to system, from hustle to ownership, on your schedule.",
  },
  {
    at: 0.66,
    eyebrow: "03. The First Cohort",
    title: "Be Among The First 200 Inside SAMZ Academy.",
    body: "Early signups unlock priority access to the marketplace, regional rallies, and badge cohort one.",
  },
];

export const PILLARS = [
  {
    tag: "Academy",
    title: "SAMZ Academy",
    body: "Six-course online certification covering career foundation, performance, monetization, digital growth, financial literacy, and ecosystem navigation. Complete it. Earn the badge. Get in.",
    href: "#academy",
  },
  {
    tag: "Marketplace",
    title: "AI Marketplace",
    body: "Uber-style gig matching for verified creatives. Real bookings, secure payments, zero guesswork. No more chasing. No more middlemen controlling access.",
    href: "#ecosystem",
  },
  {
    tag: "Rallies",
    title: "Regional Rallies",
    body: "Live showcase events in host cities nationwide. Perform, network, and turn proximity into opportunity inside a system that pays you to show up.",
    href: "#ecosystem",
  },
  {
    tag: "Network",
    title: "Creative Network",
    body: "Community, collaboration, and industry access designed by professionals who refuse to gate-keep. Build the relationships that actually move careers forward.",
    href: "#ecosystem",
  },
];

export const COURSES = [
  { code: "01", name: "BLUEPRINT", topic: "Career Foundation", body: "The architecture every working creative needs underneath the artistry. Strategy, identity, and how to build like a professional from day one." },
  { code: "02", name: "SPOTLIGHT", topic: "Performance Skills", body: "Stage presence, audience command, and the craft of showing up ready when the room finally turns toward you." },
  { code: "03", name: "AMPLIFY", topic: "Production & Monetization", body: "Turn your output into income streams. Production fundamentals, rights, royalties, and the levers that scale your catalog." },
  { code: "04", name: "SIGNAL", topic: "Digital Growth", body: "Build a content engine that compounds. Platform strategy, audience math, and the discipline of consistent reach without burning out." },
  { code: "05", name: "WEALTH", topic: "Financial Literacy", body: "What 90% of independent musicians never learn. Cash flow, contracts, taxes, ownership, and the long game of compounding earnings." },
  { code: "06", name: "ASCEND", topic: "Ecosystem Navigation", body: "How to operate inside the SAMZ marketplace, leverage rallies, and turn the badge into a long-term competitive advantage." },
];

export const AUDIENCE = [
  { tag: "Working Pros", title: "Stop chasing gigs.", body: "Let verified gigs come to you. Secure payments, real bookings, no more invoice ghost stories." },
  { tag: "Side-Hustle", title: "Turn your gift into income, on your schedule.", body: "Build a creative business around your life, not the other way around. Earn from the talent you already have." },
  { tag: "Career-Shifters", title: "You never stopped being an artist.", body: "There's now a system built for the people who pursued the dream once and want a real path back in." },
  { tag: "Buyers", title: "Find verified talent in minutes.", body: "Venues, brands, and corporates can book reliable, certified creatives without the agency markup or the guesswork." },
];

export const STATS = [
  { value: "90%", label: "of independent musicians never get formal business training. SAMZ fixes that." },
  { value: "6", label: "courses, one certification, one SAMZONE Badge that unlocks the entire ecosystem." },
  { value: "200", label: "founding members. Early signups get first access to the marketplace." },
  { value: "4", label: "pillars working as one flywheel: Learn, Connect, Perform, Build." },
];

export const PARTNERS = [
  "SINGERS", "MUSICIANS", "PRODUCERS", "SONGWRITERS", "ACTORS", "DANCERS", "CREATORS", "PERFORMERS",
];

export const FOOTER_LINKS = {
  Academy: ["The 6 Courses", "SAMZONE Badge", "Curriculum", "Pricing"],
  Ecosystem: ["Marketplace", "Regional Rallies", "Creative Network", "For Buyers", "For Venues"],
  Company: ["About SAMZ", "Founder", "Press", "Partnerships", "Contact"],
  Resources: ["Manifesto", "Brand", "Sponsors", "Privacy", "Terms"],
};

export const CREATIVE_TYPES = [
  "Singer / Vocalist",
  "Musician / Producer",
  "Songwriter",
  "Actor / Performer",
  "Dancer / Choreographer",
  "Content Creator",
  "Buyer / Venue / Brand",
  "Other",
];
